var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',[_c('v-progress-circular',{staticClass:"mr-2",attrs:{"indeterminate":"","color":"primary"}}),_vm._v(" You are being logged out... ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }